<script lang="tsx">
import { defineComponent, reactive, toRefs, computed } from 'vue'

import { Node } from '@antv/x6'
import { AuthBtn } from '@/components/business/FlowDeal/config'

const props = {
  node: {
    type: Node,
    default: () => ({})
  }
}

export default defineComponent({
  name: 'FlowResult',
  props,
  setup(props) {
    const { node } = props
    let flowData = reactive({ current: node.getData() })
    const { current } = toRefs(flowData)

    const showIcon = computed(() => {
      if (current.value?.logs?.length) {
        const res = current.value?.logs.find((el: any) => el.action === AuthBtn.CANCEL)
        return !!res
      }
      return false
    })

    return () => (
      <div class={'flow-wrap'}>
        <div class="flow-name">{current.value.name}</div>
        <div class="tw-flex tw-justify-center tw-items-center">
          <span class="flow-operator">
            {current.value?.operators.join('、')}
            {showIcon.value ? <span class="icon iconfont icon-chehui tw-ml-2"></span> : ''}
          </span>
        </div>
      </div>
    )
  }
})
</script>
<style scoped lang="scss">
.flow-wrap {
  border-radius: 61px;
  box-shadow: 0 2px 5px 0 #00000014;
  width: 136px;
  height: 62px;
  padding: 10px 12px;
  justify-content: center;
  align-items: flex-start;
  background: #fff;
  cursor: pointer;
  text-align: center;
  .flow-name {
    color: #5687ff;
    font-size: 14px;
    line-height: 22px;
  }
  .flow-operator {
    color: #999999;
    font-size: 12px;
    line-height: 20px;
  }
  .flow-icon {
    margin-left: 2px;
    width: 16px;
    height: 16px;
  }
}
.flow-warp__done {
  box-shadow: 0 0 0 3px rgba(48, 129, 242, 0.2);
  border: 1px solid #5687ff;
  box-sizing: border-box;
}
.flow-warp__reject {
  box-shadow: 0 0 0 2px #fab5b5 !important;
  border: 1px solid #f34444 !important;
  box-sizing: border-box;
}
</style>
